import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { request } from '../../../utils/request';
import { message } from '../../../components/Message';

export const getCheck = createAsyncThunk(
    'check/getCheck',
    async ({ date, owner, company, period, products, promocode = '', paysystem = null, wallet = null }, { rejectWithValue }) => {
        try {
            let data = {
                "date": { "dateString": date },
                "owner": { "id": owner },
                "company": { "id": company },
                "period": { "id": period },
                products,
            };

            if (promocode) {
                data["promocode"] = { "code": promocode };
            }

            if (paysystem) {
                data["paysystem"] = paysystem;
            }

            if (wallet && wallet.id) {
                data["wallet"] = wallet;
            }

            let response = await request("AppDinnerController", "GetCheck", data);

            if (response.result) {
                if (response.data.promocode.result !== undefined) {
                    if (response.data.promocode.result) {
                        console.log('promo_message', response.data.promocode.message);
                    } 
                }
                return response.data;
            } else if (response.errors && Array.isArray(response.errors) && response.errors.length) {
                message({ type: 'default', title: 'Ошибка', body: response.errors[0].description });
                return rejectWithValue(response.errors[0].description);
            } else if (response.message || response.data?.message) {
                message({ type: 'default', title: 'Ошибка', body: response.message || response.data?.message });
                return rejectWithValue(response.message || response.data?.message);
            } else {
                message({ type: 'default', title: 'Ошибка', body: 'Непредвиденная ошибка getCheck' });
                return rejectWithValue('Непредвиденная ошибка getCheck');
            }
        } catch (error) {
            console.log(error);
            return rejectWithValue(error.message);
        }
    }
);

const saveCheckToLocalStorage = (state) => {
    localStorage.setItem('check', JSON.stringify(state));
};

const initialState = JSON.parse(localStorage.getItem('check')) || {
    getCheckStatus: null,
    checkData: null,
    numberOrderCheck: null,
    paymentLinks: [],
    payUrl: null,
};

const cartSlice = createSlice({
    name: 'check',
    initialState,
    extraReducers: (builder) => {
        builder
            // getCheck
            .addCase(getCheck.pending, (state) => {
                state.getCheckStatus = 'pending';

                saveCheckToLocalStorage(state);
            })
            .addCase(getCheck.fulfilled, (state, action) => {
                state.getCheckStatus = 'fulfilled';
                state.checkData = action.payload;

                saveCheckToLocalStorage(state);
            })
            .addCase(getCheck.rejected, (state) => {
                state.getCheckStatus = 'rejected';
                state.checkData = null;
                
                saveCheckToLocalStorage(state);
            })
    },
    reducers: {
        setNumberOrderCheck: (state, action) => {
            state.numberOrderCheck = action.payload;

            saveCheckToLocalStorage(state);
        },
        clearCheckData: (state) => {
            state.checkData = null;

            saveCheckToLocalStorage(state);
        },
        addPaymentLink: (state, action) => {
            const { numberOrderCheck } = action.payload;
            const index = state.paymentLinks.findIndex(link => link.numberOrderCheck === numberOrderCheck);
        
            if (index !== -1) {
                // Если ссылка уже есть, заменяем её
                state.paymentLinks[index] = action.payload;
            } else {
                // Если нет, добавляем новую
                state.paymentLinks.push(action.payload);
            }

            saveCheckToLocalStorage(state);
        },
        removePaymentLinkById: (state, action) => {
            const numberOrderCheck = action.payload;
            state.paymentLinks = state.paymentLinks.filter(link => link.numberOrderCheck !== numberOrderCheck);

            saveCheckToLocalStorage(state);
        },
        setPayUrl: (state, action) => {
            state.payUrl = action.payload;
        
            saveCheckToLocalStorage(state);
        },
    },
});

export const {
    setNumberOrderCheck,
    clearCheckData,
    addPaymentLink,
    removePaymentLinkById,
    setPayUrl,
} = cartSlice.actions;

export default cartSlice.reducer;